import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { PATHS, LOAD } from 'src/config/app'
import Copydeck from '@/config/copydeck.json' 
// import AnalyticsService from '@/services/AnalyticsService'

// ROUTES 
import Loading from '@/pages/Loading' 
import Unsupported from '@/pages/Unsupported' 
// import RatingOne from '@/pages/RatingOne'
// import RatingTwo from '@/pages/RatingTwo'
// import RatingThree from '@/pages/RatingThree'
// import RatingFour from '@/pages/RatingFour'
// import RatingFive from '@/pages/RatingFive'


const lang_en = Copydeck.en
const site_title = lang_en['meta-site-title']
 

// MODE
// mode: 'hash', // eg /#/mypage
// mode: 'history', // eg /mypage (requires htaccess or equivalent for deploy)
// mode: 'abstract', // internal routing, no url change
const mode = 'hash' 

// INIT
Vue.use(Router)
const router = new Router({

  base: PATHS.BASE,
  mode: mode, 

  // Routes
  routes: [

    {
      path: `${PATHS.BASE}${PATHS.LOADING}`,
      name: PATHS.LOADING,
      component: Loading,
    }, 

    {
      path: `${PATHS.BASE}${PATHS.UNSUPPORTED}`,
      name: PATHS.UNSUPPORTED,
      component: Unsupported,
    }, 

    {
      path: PATHS.BASE,
      name: PATHS.HOME,
      meta: {
        title: site_title
      },
      component: () => import(/* webpackChunkName: "home" */ '@/pages/Home'),
      children: [
        {
          path: `${PATHS.BASE}${PATHS.RATING_ONE}`,
          name: PATHS.RATING_ONE,
          component: () => import(/* webpackChunkName: "rating-one" */ '@/pages/RatingOne'),
          meta: {
            title: `${site_title} - ${lang_en['meta-star-rating-one-title']}`
          }
        },

        {
          path: `${PATHS.BASE}${PATHS.RATING_TWO}`,
          name: PATHS.RATING_TWO,
          //component: RatingTwo, 
          component: () => import(/* webpackChunkName: "rating-two" */ '@/pages/RatingTwo'),
          meta: {
            title: `${site_title} - ${lang_en['meta-star-rating-two-title']}`
          }
        },

        {
          path: `${PATHS.BASE}${PATHS.RATING_THREE}`,
          name: PATHS.RATING_THREE,
          component: () => import(/* webpackChunkName: "rating-three" */ '@/pages/RatingThree'),
          //component: RatingThree,
          meta: {
            title: `${site_title} - ${lang_en['meta-star-rating-three-title']}`
          }
        },

        {
          path: `${PATHS.BASE}${PATHS.RATING_FOUR}`,
          name: PATHS.RATING_FOUR,
          component: () => import(/* webpackChunkName: "rating-four" */ '@/pages/RatingFour'),
          //component: RatingFour,
          meta: {
            title: `${site_title} - ${lang_en['meta-star-rating-four-title']}`
          }
        },

        {
          path: `${PATHS.BASE}${PATHS.RATING_FIVE}`,
          name: PATHS.RATING_FIVE,
          //component: RatingFive,
          component: () => import(/* webpackChunkName: "rating-five" */ '@/pages/RatingFive'),
          meta: {
            title: `${site_title} - ${lang_en['meta-star-rating-five-title']}`
          }
        }
      ]
      
    },
 

    // catch all/404
    {
      path: '*',
      redirect: PATHS.BASE
    }
  ],
})
export default router



// ROUTE GUARDS

// LOADING REDIRECT
router.beforeEach((to, from, next) => {
  
  const isLoadingRoute = ( to.name === 'loading' )
  const state = store.state.app.loading.state
  const isLoadingComplete = ( state === LOAD.STATES.COMPLETE )
  const isRouteString = (typeof to.name === 'string') 
  const redirectToLoadingRoute = (!isLoadingRoute && !isLoadingComplete && isRouteString)
   
  if (redirectToLoadingRoute) {
    store.commit('app/setRouteAfterLoad', to.path)    // set after load route
    return next({ name: 'loading', replace: true, })  // set route to loading
  } else {
    next()
  }
})

// START IF ABSTRACT MODE
if (router.mode === 'abstract') {
  router.replace('/')
}

// AFTER HOOK
router.afterEach((to) => {
  if (to.matched.length > 0) {
    store.commit('app/setRoute', {
      parent: to.matched[0].name,
      child: (to.matched[1] || { name: null }).name,
    })
    // AnalyticsService.sendPageview(to.fullPath)
 
    document.title = to.meta.title || site_title
    
  }
})

window.router = router
